// extracted by mini-css-extract-plugin
export default {"block":"SectionBlock_block__B5rrE","margin":"SectionBlock_margin__Gvmw+","divider":"SectionBlock_divider__5jR3O"};